/*
 * @Author: your name
 * @Date: 2021-07-28 19:49:52
 * @LastEditTime: 2021-11-12 16:01:09
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /front-standard-product/src/assets/js/public/globalGateWayConfig.js
 */
export default [
  // 公共接口
  '/p/c/getAppTitle',
  '/p/c/getCaptcha',
  '/p/c/login',
  '/p/cs/getUserConfig',
];
